import { StatInsightCard } from "./StatInsightCard"

export const WhyCouponsWorkSection = () => {

  const stats = [
    {
      percentage: "80",
      title: "Discover New Businesses",
      description:
        "An offer is the ultimate introduction. It removes hesitation, making it the fastest way to acquire first-time customers."
    },
    {
      percentage: "48",
      title: "Expect Special Offers",
      description:
        "Modern shoppers actively seek value. Publishing deals keeps you competitive and prevents losing customers to the business next door."
    },
    {
      percentage: "38",
      title: "Spend More Per Visit",
      description:
        "Coupons don't shrink margins—they encourage higher spending and larger basket sizes"
    }
  ]

  return (
    <div>
      <div className="hidden lg:block">
    <section className="w-full flex justify-center py-12 bg-[#FAFAFA]">

      <div className="w-full max-w-[1700px] px-6 text-center">

        {/* top label */}
        <div className="flex justify-center items-center gap-3 text-gray-600 mb-6">
          <span className="w-2.5 h-2.5 bg-red-600 rounded-full"></span>
          <span className="text-[16px]">Real Buying Signals</span>
        </div>

        {/* heading */}
        <h2 className="text-[52px] font-medium text-gray-900 mb-6">
          Why Coupons Work
        </h2>

        {/* description */}
        <p className="text-gray-600 text-[18px] max-w-[720px] mx-auto mb-16 leading-relaxed">
          The data speaks for itself. Coupons don't just attract foot traffic—they influence buying decisions, drive local discovery, and increase total spend.
        </p>

        {/* cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {stats.map((item, index) => (
            <StatInsightCard
              key={index}
              percentage={item.percentage}
              title={item.title}
              description={item.description}
            />
          ))}

        </div>

      

      </div>

    </section>
    </div>

    <div className="block lg:hidden mt-36">
    <section className="w-full flex justify-center py-12 bg-white">

      <div className="w-full max-w-[1700px] text-start">

        {/* top label */}
        <div className="flex max-[1024px]:justify-center justify-start items-center gap-3 text-gray-600 mb-6">
          <span className="w-2.5 h-2.5 bg-red-600 rounded-full"></span>
          <span className="text-[16px]">Real Buying Signals</span>
        </div>

        {/* heading */}
        <h2 className="text-[30px] max-[1024px]:text-center font-medium text-gray-900 mb-4">
          Why Coupons Work
        </h2>

        {/* description */}
        <p className="text-gray-600 text-[12px] max-[1024px]:text-center max-w-[720px] mx-auto mb-6 leading-relaxed">
          The data speaks for itself. Coupons don't just attract foot traffic—they influence buying decisions, drive local discovery, and increase total spend.
        </p>

        {/* cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {stats.map((item, index) => (
            <StatInsightCard
              key={index}
              percentage={item.percentage}
              title={item.title}
              description={item.description}
            />
          ))}

        </div>

      

      </div>

    </section>
    </div>
    </div>

          


  )
}